/**
 * Expansion work orders use BASE.SUFFIX (e.g. 9534.10). JSON/JS numeric storage drops
 * trailing suffix zeros (9534.10 → 9534.1, 7060.20 → 7060.2). Recover canonical labels.
 */
export function normalizeExpansionWorkOrderDisplay(woRaw) {
  if (woRaw == null || woRaw === "") return "";
  const s = typeof woRaw === "string" ? woRaw.trim() : String(woRaw);
  if (!s) return "";
  const dot = s.indexOf(".");
  if (dot < 0) return s;

  const base = s.slice(0, dot).trim();
  const frac = s.slice(dot + 1).trim();
  if (!base || !frac) return s;

  // Preserve explicit multi-digit suffixes (01, 11, 002, …).
  if (frac.length >= 2) return `${base}.${frac}`;

  // Single-digit suffix from numeric storage: 9534.1 → 9534.10, 7060.2 → 7060.20.
  if (/^\d$/.test(frac)) {
    return `${base}.${frac}0`;
  }

  return s;
}

export function compareExpansionWorkOrderDisplay(a, b) {
  const woA = normalizeExpansionWorkOrderDisplay(a);
  const woB = normalizeExpansionWorkOrderDisplay(b);
  return woA.localeCompare(woB, undefined, { numeric: true, sensitivity: "base" });
}
